const Images = {
    orders: require('../assets/images/orders.png'),
    dashboard: require('../assets/images/dashboard.png'),
    logout: require('../assets/images/logout.png'),
    product: require('../assets/images/Xpanse.png'),
    xpanse: require('../assets/images/Xpanse.png'),
    beans: require('../assets/images/beans.png'),
    profile: require('../assets/images/profile.png'),
    reviews: require('../assets/images/REVIEWS.png'),
    emptyGif: require('../assets/images/emptyCart.json'),
    emptyCart: require('../assets/images/emptyCartImage.jpg'),
    emptyCartImg: require('../assets/images/emptyCart.png'),

    card: require('../assets/images/card.png'),
    cash: require('../assets/images/cash.png'),
    upi: require('../assets/images/upi.png'),

    noProductSelected: require('../assets/images/emptybox.png'),
    noOrders: require('../assets/images/noOrders.png'),
    qrImage: require('../assets/images/QRimage.png'),
    invoiceLogo: require('../assets/images/invoice-logo.jpg'),

    errorScreen: require('../assets/images/errorScreen.png'),
    xpanseLabel: require('../assets/images/xpanceLabel.png'),


    // Thumbnails
    loginProcess: require('../assets/images/thumbnails/loginProcess.png'),
    dashboardOverView: require('../assets/images/thumbnails/dashboardOverView.png'),
    outletManagement: require('../assets/images/thumbnails/outletManagement.png'),
    outletOffers: require('../assets/images/thumbnails/outletOffers.png'),
    productStockManagement: require('../assets/images/thumbnails/productStockManagement.png'),
    addonStockManagement: require('../assets/images/thumbnails/addonsStockManagement.png'),
    ordersReport: require('../assets/images/thumbnails/ordersReport.png'),
    criticalStockReport: require('../assets/images/thumbnails/criticalStockReport.png'),
    stockTransactionReport: require('../assets/images/thumbnails/stockTransactionReports.png'),
    paymentTransactionReport: require('../assets/images/thumbnails/paymentTransactions.png'),
    complimentaryOrder: require('../assets/images/thumbnails/complimentaryOrder.png'),
    orderNotReceieved: require('../assets/images/thumbnails/orderNotReceieved.png'),
    damagedRawMaterial: require('../assets/images/thumbnails/damagedRawMaterial.png'),
    posSupport: require('../assets/images/thumbnails/posSupport.png'),
    customerSupport: require('../assets/images/thumbnails/customerSupport.png'),
    inventoryStockListing: require('../assets/images/thumbnails/inventoryStockListing.png'),
    productsListing: require('../assets/images/thumbnails/productsListing.png'),
    labelPrinter: require('../assets/images/thumbnails/labelPrinter.png'),
    controllingProduct: require('../assets/images/thumbnails/controllingProduct.png'),
}

export default Images;